
<!-- CAMP IMAGE PC VERSION-->
<div class="container justify-content-center d-none d-lg-block">
  <div class="row d-flex w-100 justify-content-center text-center">
    <div class="col-12 justify-content-center text-center">
      <img src="{{campaign.imagen}}" width="1080px" height="450px"/>
    </div>
  </div>
</div>

<!-- CAMP IMAGE TABLET VERSION-->
<div class="container d-none d-md-block d-lg-none justify-content-center p-0">
  <div class="row d-flex w-100 justify-content-center text-center">
    <div class="col-12 justify-content-center text-center">
      <img src="{{campaign.imagenTablet}}" />
    </div>
  </div>
</div>

<!-- CAMP IMAGE MOBILE VERSION-->
<div class="container d-block d-md-none justify-content-center p-0">
  <div class="row d-flex w-100 justify-content-center text-center">
    <div class="col-12 justify-content-center text-center">
      <img src="{{campaign.imagenMovil}}" width="381px" height="375px"/>
    </div>
  </div>
</div>


<div class="container">
  <div class="row d-flex w-100 justify-content-center pt-4 pb-4">
    <div class="col-12 justify-content-center text-center">
      <span class="campaign-legend">{{campaign.descripcion}}</span>
    </div>
  </div>
</div>

<!--PROMOS SECTION-->
<nav class="navbar navbar-light justify-content-center bg-light">

  <!-- Show for >= Medium Devices -->
  <div class="container d-none d-md-block nopadding justify-content-center bg-light" *ngIf="promos!=undefined && promos.length>0">
    <div class="row w-100 nopadding justify-content-center">

      <div class="col-sm-0 col-md-0 col-lg-1-4 nopadding d-flex align-items-center">
        <a class="btn d-none d-lg-block"><img (click)="onPrevPage()" src="assets/img/Navegador_Izq.png" *ngIf="pages.length>1" /></a>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-10 ">
        <div class="container justify-content-center">

          <div class="row w-100 pr-lg-4">
            <div class="col-lg-3 col-md-6 col-sm-12" *ngFor="let promo of promos; let i = index">
              <div class="promotion-box" [routerLink]="['/showPromoCamp',promo.idPromocion,idCamp,currentPage]"
                   style="outline: transparent;" *ngIf="promo.idTipoPromocion===1">
                <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="168">
                <div class="card-body">
                  <img class="card-img-left" src="{{promo.comercio.urlLogoImagen}}" alt="{{promo.comercio.nombre}}"
                       width="75" height="75">
                  <h5 class="card-title commerce-name-long" *ngIf="promo.comercio.nombre.length>25">
                    {{promo.comercio.nombre}}</h5>
                  <h5 class="card-title commerce-name" *ngIf="promo.comercio.nombre.length<=25">
                    {{promo.comercio.nombre}}</h5>
                  <p class="card-text promo-name">{{promo.nombre}}</p>
                </div>
                <div class="card-footer text-right">
                  <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
                  <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                          [routerLink]="['/showPromoCamp',promo.idPromocion,idCamp,currentPage]">
                    <div>
                      <span class="promo-more">Conoce m&aacute;s</span><span> </span><span><i
                      class="icon icon-chevron-right-small" aria-hidden="true"></i></span>
                    </div>
                  </button>
                </div>
              </div>
              <div class="promotion-box" style="outline: transparent;" *ngIf="promo.idTipoPromocion===3"
                   (click)="goToLink(promo.urlTargetInformativa, promo.targetInformativa, promo.nombre)">
                <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="319">

                <div class="card-footer text-right">
                  <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
                  <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                          [routerLink]="['/showPromoCamp',promo.idPromocion,idCamp,currentPage]">
                  </button>
                </div>

              </div>

              <div class="card-footer-margin">
                &nbsp;
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-sm-0 col-md-0 col-lg-1-4 nopadding d-flex align-items-center">
        <a class="btn d-none d-lg-block"><img (click)="onNextPage()" src="assets/img/Navegador_Der.png" *ngIf="pages.length>1" /></a>
      </div>

    </div>

  </div>


  <div class="container d-none d-md-block justify-content-center" *ngIf="promos==undefined || promos.length==0">
    <div class="row w-100">
      <div class="col-md-12 col-lg-12 justify-content-end" >
        <hr class="stylePC" />
      </div>
    </div>
    <div class="row w-100 justify-content-center">
      <div class="col-md-12 col-lg-12 justify-content-center" >
        <p class="not-found-style text-center">No se encontraron resultados.</p>
      </div>
    </div>
  </div>
  <!--END Show for >= Medium Devices -->

  <!-- Show for <= SMALL Devices -->
  <div class="container d-block d-md-none nopadding justify-content-center bg-light" *ngIf="promosMobile!=undefined && promosMobile.length>0">

    <div class="row scrolling-wrapper-flexbox">
      <div class="promobox-mobile" *ngFor="let promo of promosMobile; let i = index">
        <div class="promotion-box" [routerLink]="['/showPromoCamp',promo.idPromocion,idCamp,currentPage]"
             style="outline: transparent;" *ngIf="promo.idTipoPromocion===1">
          <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="168">
          <div class="card-body">
            <img class="card-img-left" src="{{promo.comercio.urlLogoImagen}}" alt="{{promo.comercio.nombre}}"
                 width="75" height="75">
            <h5 class="card-title commerce-name-long" *ngIf="promo.comercio.nombre.length>25">
              {{promo.comercio.nombre}}</h5>
            <h5 class="card-title commerce-name" *ngIf="promo.comercio.nombre.length<=25">
              {{promo.comercio.nombre}}</h5>
            <p class="card-text promo-name">{{promo.nombre}}</p>
          </div>
          <div class="card-footer text-right">
            <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
            <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                    [routerLink]="['/showPromoCamp',promo.idPromocion,idCamp,currentPage]">
              <div>
                <span class="promo-more">Conoce m&aacute;s</span><span> </span><span><i
                class="icon icon-chevron-right-small" aria-hidden="true"></i></span>
              </div>
            </button>
          </div>
        </div>
        <div class="promotion-box" style="outline: transparent;" *ngIf="promo.idTipoPromocion===3"
             (click)="goToLink(promo.urlTargetInformativa, promo.targetInformativa, promo.nombre)">
          <img class="card-img-top" src="{{promo.urlImagen}}" alt="{{promo.nombre}}" width="221" height="319">

          <div class="card-footer text-right">
            <!-- <button type="button" class="btn-bc-tertiary btn btn-xs btn-default" (click)="showPromo($event)" id="{{promo.idPromocion}}"> -->
            <button type="button" class="btn-bc-tertiary btn btn-xs btn-default"
                    [routerLink]="['/showPromoCamp',promo.idPromocion,idCamp,currentPage]">
            </button>
          </div>

        </div>

        <div class="card-footer-margin">
          &nbsp;
        </div>
      </div>
    </div>



  </div>

  <!-- Not Found Records Mobile Version-->
  <div class="container d-block d-md-none justify-content-center" *ngIf="promosMobile===undefined || promosMobile.length===0">
    <div class="row w-100">
      <div class="col-md-12 col-lg-12 justify-content-end" >
        <hr class="stylePC" />
      </div>
    </div>
    <div class="row w-100 justify-content-center">
      <div class="col-md-12 col-lg-12 justify-content-center" >
        <p class="not-found-style text-center">No se encontraron resultados.</p>
      </div>
    </div>
  </div>
  <!--END Show for <=  SMALL Devices -->



</nav>


<nav class="navbar d-none d-md-block navbar-light justify-content-center bg-light">
  <div class="container bg-light justify-content-center">

    <div class="row justify-content-center pr-lg-4">
      <div class="col-12 d-flex justify-content-center align-items-center">

        <a class="btn d-none d-md-block d-lg-none" href="#" *ngIf="pages.length>1"><img (click)="onPrevPage()" src="assets/img/Navegador_Izq.png" width="15px"
                                                                 height="49px" /></a>&nbsp;
        <a class='btn' *ngFor="let page of pages">
          <img (click)="showPage(page.pageNumber)" class="" src="{{page.imageIcon}}" id="{{page.pageNumber}}" />
        </a>&nbsp;
        <a class="btn d-none d-md-block d-lg-none" href="#" *ngIf="pages.length>1"><img (click)="onNextPage()" src="assets/img/Navegador_Der.png" width="15px"
                                                                 height="49px" /></a>

      </div>
    </div>
  </div>
</nav>

<ngx-spinner></ngx-spinner>
<!--END PROMOS SECTION-->

